import { schema } from 'normalizr'

import { appointmentArray } from './appointments'
import { patient } from './patients'

export const treatment = new schema.Entity('treatment', { patient, appointments: appointmentArray }, { idAttribute: '_id' })
export const treatmentArray = new schema.Array(treatment)
